import { render, staticRenderFns } from "./addGdtparams.vue?vue&type=template&id=1827cc85&"
import script from "./addGdtparams.vue?vue&type=script&lang=js&"
export * from "./addGdtparams.vue?vue&type=script&lang=js&"
import style0 from "./addGdtparams.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1827cc85')) {
      api.createRecord('1827cc85', component.options)
    } else {
      api.reload('1827cc85', component.options)
    }
    module.hot.accept("./addGdtparams.vue?vue&type=template&id=1827cc85&", function () {
      api.rerender('1827cc85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/components/addGdtparams.vue"
export default component.exports